import React from 'react';
import LoveButton from '../item/loveButton/loveButton.js'
import FullscreenSocialDownload from './fullscreenSocialDownload.js';
import FullscreenShareButtons from './fullscreenShareButtons.js';
import cartApi from '../../store/cartApi.js'
import {utils} from '../../utils'
import {itemActions} from '../../utils'
import {versionManager} from '../../versioning/proGalleryVersionManager.js';


class FullscreenMobileBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showShare: false
    }
  }

  toggleShare(forceVal) {
    this.setState({
      showShare: (_.isUndefined(forceVal) ? !this.state.showShare : forceVal)
    });
  }

  render() {
   var isStoreGallery = utils.isStoreGallery();
    this.props.love.showCounter = this.props.styleParams.loveCounter;
    var mobileLoveButton = (this.props.styleParams.loveButton ? (
      <LoveButton
        layout="fullscreen"
        device='mobile'
        {...this.props.love}
      />
    ) : '');

    let fullscreenSocialDownload = (
      <FullscreenSocialDownload
        layout="fullscreen"
        device='mobile'
        current={this.props.current}
        styleParams={this.props.styleParams}
      />
    )


    var mobileBack = versionManager.useFullscreenNewMobileLayout() ? (
      <div className={"fullscreen-mobile-bar fullscreen-mobile-top back"}>
        <div>
          <div className="fullscreen-back-store"
             onClick={() => this.props.actions.toggleShareScreen(false)}/>
        </div>
      </div>
    ) : (
      <div className={"fullscreen-mobile-bar fullscreen-mobile-top"}>
        <div>
          <i className="fullscreen-close progallery-svg-font-icons-back"
             onClick={() => this.props.actions.toggleInfo(false)}/>
        </div>
      </div>
    );

    var mobileShare = (type) => {
      var icons = (type == 'top' ? mobileTopShare : mobileRightShare);
      var cls = "fullscreen-more progallery-svg-font-icons-more_actions";

      return isStoreGallery ? '' : this.props.styleParams.allowSocial ? (
        (utils.isSite() ? (
          <div>
            <i className={cls}
               onClick={() => this.toggleShare()}/>
            {icons}
          </div>
        ) : (
          <div>
            <i className={cls + ' show-tooltip '}
               onMouseOver={(e) => itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor')}
               onMouseOut={() => itemActions.hideTooltip()}
            />
            {icons}
          </div>
        ))
      ) : '';
    };

    const shareIcon = this.props.styleParams.allowSocial ? (<i className='progallery-svg-font-icons-share-store share-icon' onClick={() => this.props.actions.toggleShareScreen()}/>) : null
    const newMobileShare = (
      <div className="fullscreen-social">
        {fullscreenSocialDownload}
        {mobileLoveButton}
        {shareIcon}
      </div>
    );

    // var mobileCart = isStoreGallery ? (
    //   <div className="disabled-mobile-cart"></div>
    //   //  <div className="fullscreen-mobile-cart" onClick={() => cartApi.showCart()}></div>
    // ) : '';

    var mobileTopShare = this.props.styleParams.allowSocial && !versionManager.useFullscreenNewMobileLayout() ? (
      <div className={"fullscreen-icon fullscreen-social-share-box"}>
        <FullscreenShareButtons item={this.props.current.item}/>
        {fullscreenSocialDownload}
      </div>
    ) : (this.props.styleParams.allowDownload ? (
      <div className={"fullscreen-icon fullscreen-social-share-box"}>
        {fullscreenSocialDownload}
      </div>
    ) : '');

    const mobileShareContainer = versionManager.useFullscreenNewMobileLayout() ? newMobileShare : mobileShare('top');

    var mobileTopClassNames = "fullscreen-mobile-bar fullscreen-mobile-top";
    mobileTopClassNames += (this.state.showShare ? ' share' : '');
    mobileTopClassNames += (versionManager.useFullscreenNewMobileLayout() ? ' store' : '')
    var mobileTop = (
      <div className={mobileTopClassNames}>
        <div>
          <i className="fullscreen-close progallery-svg-font-icons-back"
             onClick={() => this.props.actions.close()} />
          {mobileShareContainer}
        </div>
      </div>
    );

    var mobileBottom = (
      <div className="fullscreen-mobile-bar fullscreen-mobile-bottom">
        <div>
          {mobileLoveButton}
          { this.props.current.hasInfo ? (
            <i
              className={"fullscreen-info progallery-svg-font-icons-" + (this.props.showInfo ? 'minus' : 'plus')}
              onClick={() => this.props.actions.toggleInfo()} />
          ) : ''}
        </div>
      </div>
    );

    var mobileRightShare = this.props.styleParams.allowSocial ? (
      <div className={"fullscreen-icon fullscreen-social-share-box vertical"}>
        <FullscreenShareButtons item={this.props.current.item}/>
        {fullscreenSocialDownload}
      </div>
    ) : (this.props.styleParams.allowDownload ? (
      <div className={"fullscreen-icon fullscreen-social-share-box vertical"}>
        {fullscreenSocialDownload}
      </div>
    ) : '');

    var mobileRight = (
      <div className={"fullscreen-mobile-bar fullscreen-mobile-right " + (this.state.showShare ? 'share' : '')}>
        <div>
          {mobileShare('right')}
          { this.props.current.hasInfo ? (
            <i
              className={"fullscreen-info progallery-svg-font-icons-" + (this.props.showInfo ? 'minus' : 'plus')}
              onClick={() => this.props.actions.toggleInfo()} />
          ) : ''}
        </div>
      </div>
    );

    var mobileLeftClassNames = "fullscreen-mobile-bar fullscreen-mobile-left";
    mobileLeftClassNames += (isStoreGallery ? ' store' : '')
    var mobileLeft = (
      <div className={mobileLeftClassNames}>
        <div>
          <i className="fullscreen-close progallery-svg-font-icons-back"
             onClick={() => this.props.actions.close()}/>
          {mobileLoveButton}
        </div>
      </div>
    );

    var mobileBars = [];
    if (utils.isSmallScreen()) {
      if (versionManager.useFullscreenNewMobileLayout() && this.props.showShareScreen) {
        //more info is shown - display only the back button
        mobileBars[0] = mobileBack;
        mobileBars[1] = false;
      } else if (versionManager.useFullscreenNewMobileLayout() || utils.isVerticalScreen()) {
        //portrait screen
        mobileBars[0] = mobileTop;
        mobileBars[1] = mobileBottom;
      } else {
        //landscape screen
        mobileBars[0] = mobileLeft;
        mobileBars[1] = mobileRight;
      }
    }

    return this.props.isFirst ? (mobileBars[0] || false) : (mobileBars[1] || false);
  }
}

export default FullscreenMobileBar;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenMobileBar.js